"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wallets = exports.Wallet = void 0;
class Wallet {
    constructor(wallet) {
        this.amount = 0;
        this.inOrders = 0;
        if (!wallet)
            return;
        this.coin = wallet.coin || 'BTC';
        this.name = wallet.name || 'Bitcoin';
        this.amount = wallet.amount || 0;
        this.fiat = wallet.fiat || false;
        this.address = wallet.address || '';
        this.inOrders = wallet.inOrders || 0;
    }
}
exports.Wallet = Wallet;
class Wallets {
    constructor() {
        this.current = 'BTC';
        this.list = {};
    }
}
exports.Wallets = Wallets;
//# sourceMappingURL=wallet.js.map